module.exports = __webpack_public_path__ + "img/32a9cd3.jpg";